import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function OfferSection() {
  return <section id="oferta" className="w-full scroll-mt-4 bg-[#10243D]" data-id="element-92" data-mp="8nf1rsz8ipr5">
      <div className="mx-auto max-w-6xl px-4 py-10 md:py-12" data-id="element-93" data-mp="8m3wtpu1zbyg">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-white md:text-[40px]" data-id="element-94" data-mp="deevkpd24rpf">
          Menos de lo que cuesta una pizza. Dura toda su infancia.
        </h2>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.55
      }} className="mx-auto mt-7 max-w-lg rounded-card border border-gold/70 bg-deep-blue p-7 text-center shadow-2xl md:p-8" data-id="element-95" data-mp="mdsb9zrrycil">
          <p className="text-lg font-semibold text-cream" data-id="element-96" data-mp="2t6ugpajc9foh">
            Biblia en Cómic — versión digital
          </p>

          <div className="mt-3 flex items-end justify-center gap-3" data-id="element-97" data-mp="2y67bchggbr1m">
            <span className="text-xl text-cream/45 line-through" data-id="element-98" data-mp="12p3676i6jmp8">$39.900</span>
            <span className="font-display text-5xl font-black text-[#75B989] md:text-6xl" data-id="element-99" data-mp="xvqvm0ac5gfh">
              $18.900
            </span>
          </div>
          <p className="mt-2 text-sm font-medium text-cream/65" data-id="element-100" data-mp="svm99tmqxrhc">
            Pago único · Sin suscripciones · Acceso de por vida
          </p>

          <div className="mt-7" data-id="element-101" data-mp="1lmmkaojhvvii">
            <CtaButton label="DESCARGAR AHORA" size="lg" onDark href="https://totaliadigital.com/cart/50437968429249:1" data-id="element-102" data-mp="1lluopdpwdxs8" />
          </div>

          <div className="mt-7 rounded-card border border-[#75B989]/40 bg-[#75B989]/10 px-6 py-5 text-center" data-id="element-103" data-mp="1cjv64gz8iln6">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#75B989]/20" data-id="element-104" data-mp="17opnbr14pn3b">
              <ShieldCheckIcon className="h-7 w-7 text-[#9DD4AA]" aria-hidden="true" data-id="element-105" data-mp="3scu1rxsu6vq8" />
            </span>
            <p className="mt-3 font-display text-xl font-bold text-[#B6E1BE]" data-id="element-106" data-mp="3ttzpe16nq0ki">
              Garantía “Le va a encantar” — 7 días
            </p>
            <p className="mx-auto mt-2 max-w-sm text-[15px] leading-relaxed text-cream/80" data-id="element-107" data-mp="2mdk644ahq1j">
              Descárgala, léesela, pruébala con tus hijos. Si no los atrapa, te
              devolvemos el 100% de tu dinero. Sin preguntas ni vueltas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}